import { Injectable } from '@angular/core';
import moment from 'moment';
import { map, Observable } from 'rxjs';
import { HelpersService } from 'src/app/services/helpers.service';
import { Statuses } from 'src/app/enums/statuses.enum'
import { ServiceRequestService } from 'src/app/services/servicerequest.service';

@Injectable({
  providedIn: 'root'
})
export class WorkshopJobcardCreateService {

  constructor(
    private helpersService: HelpersService,
    private serviceRequest: ServiceRequestService
  ) { }

  isJobCardValid(jobcard: any, preServiceChecklist: any[]): boolean {

    if (!this.isCustomerSectionCompleted(jobcard)) {
      return false;
    }
    if (!this.isItemSectionCompleted(jobcard)) {
      return false;
    }
    if (!this.isProductsAndServicesSectionCompleted(jobcard)) {
      return false;
    }
    if (!this.isBookingSectionCompleted(jobcard)) {
      return false;
    }
    if (!this.isCustomQuestionsCompleted(jobcard)) {
      return false;
    }
    // if (!this.isPreServiceChecklistCompleted(preServiceChecklist)) {
    //   console.error('Pre-Service Checklist is not completed');
    //   return false;
    // }
    return true;
  }


  isCustomerSectionCompleted(jobcard: any): boolean {
    if (jobcard.customer && jobcard.customer?.ID > 0) {
      return true;
    } else {
      return false;
    }
  }
  isItemSectionCompleted(jobcard: any): boolean {
    if (jobcard.selectedItem && jobcard.selectedItem.id > 0) {
      return true;
    } else {
      return false;
    }
  }
  isProductsAndServicesSectionCompleted(jobcard: any): boolean {
    return !!(
      jobcard?.selectedServiceTypes && jobcard?.selectedServiceTypes.length > 0
    );
  }

  isBookingSectionCompleted(jobcard: any): boolean {
    return !!(
      jobcard?.scheduleDate &&
      jobcard?.technician &&
      jobcard?.createdBy &&
      jobcard?.selectedServiceTypes && jobcard?.selectedServiceTypes.length > 0
    );
  }

  isExtrasCompleted(jobcard: any): boolean {
    return !!(
      jobcard.clientNotes && jobcard.clientNotes.length > 0
    );
  }

  isCollectionsComplete(jobcard: any, collectionsConfigured: boolean): boolean {
    if (!collectionsConfigured) {
      return true; // If collections are not configured, consider it complete
    }

    if (!jobcard.collectionsDeliveries) return false;

    if (jobcard.collectionsDeliveries && !jobcard.collectionsDeliveries.allowCollection && jobcard.collectionsDeliveries.allowDelivery) return true;

    if (jobcard.collectionsDeliveries && jobcard.collectionsDeliveries.allowCollection && jobcard.collectionsDeliveries && jobcard.collectionsDeliveries.collectionInfo.fullAddress && jobcard.collectionsDeliveries.collectionInfo.addressDetails &&
      jobcard.collectionsDeliveries.collectionInfo.scheduleDate && jobcard.collectionsDeliveries.collectionInfo.timeSlot) {
      return true;
    } else {
      return false;
    }
  }

  isPreServiceChecklistCompleted(preServiceChecklist: any[]): boolean {
    if (this.getCompletedChecklistCount(preServiceChecklist) === this.getChecklistCount(preServiceChecklist)) {
      return true;
    } else {
      return false;
    }
  }

  isCustomQuestionsCompleted(jobcard: any): boolean {
    if (jobcard.customQuestions && jobcard.customQuestions.length > 0) {
      let valid = true;
      jobcard.customQuestions.forEach((group: any) => {
        group.customQuestions.forEach((question: any) => {
          if (question.mandatory && !question.response) {
            valid = false;
          }
        });
      });
      return valid;
    }
    return true; // If no custom questions, consider it completed
  }

  getChecklistCount(preServiceChecklist): number {
    var count = 0;
    preServiceChecklist.forEach(item => {
      if (item.frontRearCheck) {
        count += 2; // Count both front and rear if applicable
      } else {
        count++;
      }
    });
    return count;
  }

  getCompletedChecklistCount(preServiceChecklist): number {
    var count = 0;
    preServiceChecklist.forEach(item => {
      if (item.frontRearCheck && item.frontValue) {
        count++;
      }
      if (item.frontRearCheck && item.rearValue) {
        count++;
      }
      if (!item.frontRearCheck && item.defaultValue) {
        count++;
      }
    });
    return count;
  }

  convertToUpperCase(list: any) {
    list.forEach(item => {
      Object.keys(item).forEach(key => {
        if (key && key.length > 0) {
          const capitalizedKey = key === 'id' ? 'ID' : key === 'sku' ? 'SKU' : key.charAt(0).toUpperCase() + key.slice(1);
          if (capitalizedKey !== key) {
            item[capitalizedKey] = item[key];
            delete item[key];
          }
        }
      });
    });
  }

  convertSingleToUpperCase(item: any) {

    Object.keys(item).forEach(key => {
      if (key && key.length > 0) {
        const capitalizedKey = key.charAt(0).toUpperCase() + key.slice(1);
        if (capitalizedKey !== key) {
          item[capitalizedKey] = item[key];
          delete item[key];
        }
      }
    });
  }

  getAvailableSlots(
    jobcard: any,
    selectedServiceTypes: any[],
    technicians: any[],
    technicianSpecific: boolean = false,
    force: boolean = false,
    allocateFirstAvailable: boolean = false,
    // When > 0, enforce this technician (e.g. one booked from the calendar) across all
    // available dates, falling back to best-fit only if they have no availability for
    // the selected service types. Defaults to 0 so existing callers are unaffected.
    preferredTechnicianId: number = 0
  ): Observable<{ jobcard: any, technicians: any[], slotsAvailable :boolean }> {
    var slotsAvailable = false;
    if (!jobcard.fromCalendar || force) {
      const serviceTypeIDs = selectedServiceTypes.join(",");
      var startDate = jobcard.originalScheduleDate
        ? moment(jobcard.originalScheduleDate).format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DDTHH:mm:ss");

      if (jobcard.collectionsDeliveries && jobcard.collectionsDeliveries.collectionInfo && jobcard.collectionsDeliveries.collectionInfo.scheduleDate && jobcard.collectionsDeliveries.collectionInfo.timeSlot) {
        startDate = moment(moment(jobcard.collectionsDeliveries.collectionInfo.scheduleDate).format("YYYY-MM-DD") + " " +
          jobcard.collectionsDeliveries.collectionInfo.timeSlot.slotEndTime).add(1, 'hour').format("YYYY-MM-DDTHH:mm:ss");
      }

      const endDate = moment(startDate).add(1, 'month').format("YYYY-MM-DD");

      const technicianId = technicianSpecific && jobcard.technician && jobcard.technician > 0
        ? jobcard.technician
        : '';

      return this.serviceRequest.getWorkshopAvailability(
        this.helpersService.getPartnerId(),
        startDate,
        endDate,
        serviceTypeIDs,
        '',//technicianId
      ).pipe(
        map(result => {
          if (result && result.length > 0) {
            slotsAvailable = true;
            var selectedTimeSlot = result[0].Date + "T" + result[0].StartTime;
            var selectedTechnician = result[0].TechnicianID;

            // Enforce a preferred technician (e.g. the technician the job was booked
            // against from the calendar) when one is requested AND they have any slot
            // for the selected service types. Pick their slot on the booking date, else
            // their closest slot on/after it, else their earliest slot. If they have no
            // availability the API result won't contain them, so we fall through to the
            // normal best-fit logic below.
            var preferredSlot = null;
            if (preferredTechnicianId && preferredTechnicianId > 0) {
              const technicianSlots = result.filter(x => x.TechnicianID == preferredTechnicianId);
              if (technicianSlots.length > 0) {
                const preferredBookingDate = moment(jobcard.scheduleDate).format("YYYY-MM-DD");
                preferredSlot = technicianSlots.find(x => x.Date == preferredBookingDate)
                  || technicianSlots.find(x => moment(x.Date).toDate() >= moment(jobcard.scheduleDate).toDate())
                  || technicianSlots[0];
              }
            }

            var sameDates = result.filter(x => x.Date == moment(jobcard.scheduleDate).format("YYYY-MM-DD"));
            if (preferredSlot) {
              slotsAvailable = true;
              selectedTimeSlot = preferredSlot.Date + "T" + preferredSlot.StartTime;
              selectedTechnician = preferredSlot.TechnicianID;
            } else if (sameDates && sameDates.length > 0) {
              slotsAvailable = true;
              selectedTimeSlot = sameDates[0].Date + "T" + sameDates[0].StartTime;
              selectedTechnician = sameDates[0].TechnicianID;
              if (technicianId) {
                var sameTechnicians = sameDates.filter(x => x.TechnicianID == technicianId);
                if (sameTechnicians && sameTechnicians.length > 0) {
                  selectedTimeSlot = sameTechnicians[0].Date + "T" + sameTechnicians[0].StartTime;
                  selectedTechnician = sameTechnicians[0].TechnicianID;
                }
              }
            } else if (!sameDates || sameDates.length === 0 && force && !allocateFirstAvailable) {
              //No slots on the same date, force to that day           
              slotsAvailable = false;
              const earliest = result.reduce((min, item) => item.StartTime < min.StartTime ? item : min);
              selectedTimeSlot = moment(jobcard.scheduleDate).format("YYYY-MM-DD") + "T" + (earliest?.StartTime || result[0].StartTime);
              selectedTechnician = technicianId ? technicianId : result[0].TechnicianID;
            } else if (!sameDates || sameDates.length === 0 && force && allocateFirstAvailable) {
              slotsAvailable = true;
              const firstAvailable = result.filter(x => moment(x.Date).toDate() >= moment(jobcard.scheduleDate).toDate())[0];
              if (firstAvailable) {
                selectedTimeSlot = firstAvailable.Date + "T" + firstAvailable.StartTime;
                selectedTechnician = firstAvailable.TechnicianID;
              }
            }

            const updatedJobcard = {
              ...jobcard,
              technician: selectedTechnician,
              scheduleDate: moment.utc(selectedTimeSlot).format('YYYY-MM-DDTHH:mm'),
              bookedDate: new Date(moment.utc(selectedTimeSlot).format('YYYY-MM-DDTHH:mm'))
            };

            let updatedTechnicians = technicians;

            if (!technicianSpecific) {
              updatedTechnicians = technicians.map(x => {
                console.log(x.value + " => " + x.label + " => " + result.filter(y => y.TechnicianID == x.value).length);
                return {
                  ...x,
                  disabled: result.filter(y => y.TechnicianID == x.value).length == 0
                };
              });
            }

            return {
              jobcard: updatedJobcard,
              technicians: updatedTechnicians,
              slotsAvailable: slotsAvailable
            };
          }

          return { jobcard, technicians, slotsAvailable: slotsAvailable };
        })
      );
    }

    // Return observable with unchanged data if conditions not met
    return new Observable(observer => {
      observer.next({ jobcard, technicians, slotsAvailable: slotsAvailable });
      observer.complete();
    });
  }

  updateJobCardStatus(jobcard: any, statusID: number, sendComms: boolean, messageService: any, translate: any): Observable<any> {
    return new Observable(observer => {
      switch (statusID) {
        case Statuses.BOOKEDIN:
          this.serviceRequest
            .bikeReceived(jobcard.id, sendComms)
            .subscribe((jobcardRes) => {
              jobcard.statusID = jobcardRes.StatusID;
              jobcard.itemIsHere = true;
              messageService.add({
                life: 5000,
                detail: translate.instant(
                  'bikeshop.modal.update_job_card.job_card.message_bike_received_and_assigned',
                  { JobCardNo: jobcard.jobCardNo },
                ),
              });
              observer.next(jobcardRes);
              observer.complete();
            }, (err) => {
              observer.error(err);
            });
          break;
        case Statuses.WAITINGFORWORK:
          this.serviceRequest
            .waitingForWork(jobcard.id, sendComms)
            .subscribe((jobcardRes) => {
              jobcard.statusID = jobcardRes.StatusID;
              messageService.add({
                life: 5000,
                detail: translate.instant(
                  'bikeshop.modal.update_job_card.job_card.message_jobcard_assigned',
                  { JobCardNo: jobcard.jobCardNo },
                ),
              });
              observer.next(jobcardRes);
              observer.complete();
            }, (err) => {
              observer.error(err);
            });
          break;
        case Statuses.WORKINGON:
          this.serviceRequest
            .startWork(jobcard.id, sendComms)
            .subscribe((jobcardRes) => {
              jobcard.statusID = jobcardRes.StatusID;
              messageService.add({
                life: 5000,
                detail: translate.instant(
                  'bikeshop.modal.update_job_card.job_card.message_job_commenced',
                  { JobCardNo: jobcard.jobCardNo },
                ),
              });
              observer.next(jobcardRes);
              observer.complete();
            }, (err) => {
              observer.error(err);
            });
          break;
        case Statuses.WARRANTY:
          this.serviceRequest
            .startWarrantyWork(jobcard.id, sendComms)
            .subscribe((jobcardRes) => {
              jobcard.statusID = jobcardRes.StatusID;
              messageService.add({
                life: 5000,
                detail: translate.instant(
                  'bikeshop.modal.update_job_card.job_card.message_warranty_job_commenced',
                  { JobCardNo: jobcard.jobCardNo },
                ),
              });
              observer.next(jobcardRes);
              observer.complete();
            }, (err) => {
              observer.error(err);
            });
          break;
        case Statuses.COMPLETED:
          this.serviceRequest
            .readyForCollectionV2(jobcard.id, sendComms)
            .subscribe(
              (jobcardRes) => {
                jobcard.statusID = jobcardRes.StatusID;
                messageService.add({
                  life: 5000,
                  detail: translate.instant(
                    'bikeshop.modal.update_job_card.job_card.message_job_completed',
                    { JobCardNo: jobcard.jobCardNo },
                  ),
                });
                observer.next(jobcardRes);
                observer.complete();
              },
              (err) => {
                console.log(err);
                messageService.add({
                  life: 5000,
                  detail: translate.instant(
                    'bikeshop.modal.update_job_card.job_card.message_job_completed_err',
                    { JobCardNo: jobcard.jobCardNo },
                  ),
                });
                observer.error(err);
              },
            );
          break;
        case Statuses.INEEDHELP:
          this.serviceRequest.iNeedHelp(jobcard.id).subscribe((jobcardRes) => {
            jobcard.statusID = jobcardRes.StatusID;
            messageService.add({
              life: 5000,
              detail: translate.instant(
                this.helpersService.getPartnerData() &&
                  this.helpersService.getPartnerData().INeedHelpLabel
                  ? 'bikeshop.modal.update_job_card.job_card.message_job_paused_custom'
                  : 'bikeshop.modal.update_job_card.job_card.message_job_paused_i_need_help',
                {
                  JobCardNo: jobcard.jobCardNo,
                  CustomLabel:
                    this.helpersService.getPartnerData().INeedHelpLabel,
                },
              ),
            });
            observer.next(jobcardRes);
            observer.complete();
          }, (err) => {
            observer.error(err);
          });
          break;
        case Statuses.WAITINGPARTS:
          this.serviceRequest
            .waitingForParts(jobcard.id, sendComms)
            .subscribe((jobcardRes) => {
              jobcard.statusID = jobcardRes.StatusID;
              messageService.add({
                life: 5000,
                detail: translate.instant(
                  'bikeshop.modal.update_job_card.job_card.message_job_paused_waiting_parts',
                  { JobCardNo: jobcard.jobCardNo },
                ),
              });
              observer.next(jobcardRes);
              observer.complete();
            }, (err) => {
              observer.error(err);
            });
          break;
        case Statuses.WAITINGCLIENT:
          this.serviceRequest
            .waitingForClient(jobcard.id, sendComms)
            .subscribe((jobcardRes) => {
              jobcard.statusID = jobcardRes.StatusID;
              messageService.add({
                life: 5000,
                detail: translate.instant(
                  'bikeshop.modal.update_job_card.job_card.message_job_paused_waiting_client',
                  { JobCardNo: jobcard.jobCardNo },
                ),
              });
              observer.next(jobcardRes);
              observer.complete();
            }, (err) => {
              observer.error(err);
            });
          break;
        case Statuses.FITTINGCOMPLETED:
          this.serviceRequest
            .jobCompleted(jobcard.id, sendComms)
            .subscribe((jobcardRes) => {
              jobcard.statusID = jobcardRes.StatusID;
              observer.next(jobcardRes);
              observer.complete();
            }, (err) => {
              observer.error(err);
            });
          break;
        case Statuses.CANCELED:
          // this.updatingStatus = false;
          // this.selectedCancellationReason = {};
          // this.jobCancelled = true;
          observer.next(null);
          observer.complete();
          break;
        case 21:
        case 22:
        case 23:
        case 24:
        case 27:
        case 28:
        case 29:
        case 32:
        case 33:
        case 34:
        case 35://Custom statusIDs
          this.serviceRequest
            .CustomStatus(jobcard.id, sendComms, statusID)
            .subscribe((jobcardRes) => {
              jobcard.statusID = jobcardRes.StatusID;
              messageService.add({
                life: 5000,
                detail: translate.instant(
                  'bikeshop.workshop.jobcard.manage.notes.updated',
                  { JobCardNo: jobcard.jobCardNo },
                ),
              });
              observer.next(jobcardRes);
              observer.complete();
            }, (err) => {
              observer.error(err);
            });
          break;
        default:
          observer.next(null);
          observer.complete();
          break;
      }
    });
  }

}
